import React, { useEffect, useRef } from 'react';

interface ParallaxHeroProps {
  imageUrl: string;
  children: React.ReactNode;
  overlayColor?: string;
  height?: string;
}

const ParallaxHero: React.FC<ParallaxHeroProps> = ({
  imageUrl,
  children,
  overlayColor = 'rgba(0, 0, 0, 0.5)',
  height = '55vh'
}) => {
  const parallaxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrolled = window.scrollY;
        parallaxRef.current.style.transform = `translate3d(0, ${scrolled * 0.5}px, 0)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div 
      className="relative w-full overflow-hidden"
      style={{ height }}
    >
      {/* Background Image with Parallax */}
      <div 
        ref={parallaxRef}
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundImage: `url(${imageUrl})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          willChange: 'transform'
        }}
      />

      {/* Overlay */}
      <div 
        className="absolute inset-0 w-full h-full"
        style={{ backgroundColor: overlayColor }}
      />

      {/* Content */}
      <div className="relative h-full z-10">
        {children}
      </div>
    </div>
  );
};

export default ParallaxHero;